export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/check.1e17d5b2.svg","height":69,"width":86};